// extracted by mini-css-extract-plugin
export default {"collapseContainer":"src-components-Antd-Collapse-antdCollapse__collapseContainer--MJpC3","panelContainer":"src-components-Antd-Collapse-antdCollapse__panelContainer--AFMNt"};